import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { appStylesReady, ensureAppStyles, showStyleLoading } from '@/shared/appStyles';

const element = document.getElementById('root');
async function start() {
  if (!appStylesReady()) {
    showStyleLoading(element);
    if (!await ensureAppStyles()) {
      showStyleLoading(element, start);
      return;
    }
  }
  ReactDOM.createRoot(element).render(<App />);
}
start();
